module.exports = __webpack_public_path__ + "static/flags/SA-7b9aad38259bc288183837dce5b2161c.gif";